module.exports = "/_next/static/images/af-d8fb0d22695c18d1386db82b04975f4e.svg";